/**
 * Centralized URL management with automatic locale handling
 * Usage: window.location.href = URLS.shippingInfo
 */

const getLocale = (): string => {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  return pathSegments.length > 0 ? pathSegments[0] : 'de-de';
};

/* will need to retrieve some of these urls from the backend as soon as we support more languages */
export const URLS = {
  // Shop URLs
  get shippingInfo() {
    return `/${getLocale()}/service/shop/zahlung-versand`;
  },
  get aboInfo() {
    return `/${getLocale()}/service/shop/abo-informationen`;
  },
  get treuepunkte() {
    return `/${getLocale()}/treuebonus`;
  },
  get checkout() {
    return `/${getLocale()}/shop/checkout`;
  },
  get cart() {
    return `/${getLocale()}/shop/cart`;
  },
  get dosageFormImage() {
    return `/${getLocale()}/dosageform-image`;
  },
  get datenschutz() {
    return `/${getLocale()}/service/datenschutz`;
  },
  productRedirectWithONumber(oNumber: string) {
    return `/${getLocale()}/product-redirect?oNumber=${oNumber}`;
  },
  productRedirectWithUniquePacksizeId(uniquePacksizeId: string) {
    return `/${getLocale()}/product-redirect?packSizeId=${uniquePacksizeId}`;
  },
  get praemienshopCheckout() {
    return `/${getLocale()}/mein-orthomol/shop?checkout`;
  },
  get meinOrthomolShopLaunch() {
    return `/${getLocale()}/mein-orthomol/shop-launch`;
  },
};
